import { useLanguage } from '@/contexts/LanguageContext'

export function useTranslation() {
  const { language, setLanguage, t } = useLanguage()

  return {
    language,
    setLanguage,
    t,
  }
}
